import { useState } from 'react';
import Layout from '@/components/Layout';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { signIn } from 'next-auth/react';
import { getSession } from 'next-auth/react';
import { useSession } from 'next-auth/react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

const fetchUrl = process.env.NEXT_PUBLIC_BASE_ENDPOINT + 'user/data';

export default function SignUpComplete() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [repeatPassword, setRepeatPassword] = useState('');

    const [name, setName] = useState('');
    const [lastName, setLastName] = useState('');
    const [dni, setDni] = useState('');
    const [phone, setPhone] = useState('');
    const [team, setTeam] = useState('');
    const [errorMessage, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { executeRecaptcha } = useGoogleReCaptcha();

    const { data } = useSession();
    let router = useRouter();

    const handleSignupComplete = async (e) => {
        e.preventDefault();

        if (password !== repeatPassword) {
            setError('Las contraseñas no coinciden.');
            return;
        }

        setLoading(true);

        let recaptcha;
        try {
            recaptcha = await executeRecaptcha('signup');
        } catch (_err) {
            recaptcha = '';
        }

        let bodyParsed = {
            email,
            password,
            repeatPassword,
            recaptcha,
            name,
            last_name: lastName,
            dni,
            phone,
            team,
        };
        let bodyMessage = JSON.stringify(bodyParsed);

        try {
            const ret = await fetch('api/auth/signup', {
                method: 'POST',
                body: bodyMessage,
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const response = await ret.json();
            if (ret.status === 200 && response.token) {
                setError('');
                await firstSignIn(email, password);
            } else {
                setError(response.message);
            }
        } catch (error) {
            setError(error.message);
        } finally {
            setLoading(false);
        }
    };

    const firstSignIn = async (email, password) => {
        setLoading(true);
        try {
            const ret = await signIn('credentials', {
                email,
                password,
                redirect: false,
            });
            router.push('/browse');
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="signup form-pages">
                <form
                    className="signup-form form"
                    onSubmit={handleSignupComplete}
                >
                    <div className="backbutton">
                        <Link className="backbutton" href="/browse">
                            &lt; Volver
                        </Link>
                    </div>
                    <h2>Registrate en LPF Play</h2>
                    <label>Email </label>
                    <input
                        type="email"
                        placeholder="Email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    />
                    <label>Contraseña: </label>
                    <input
                        type="password"
                        placeholder="Contraseña"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    ></input>
                    <label>Repetí la contraseña: </label>
                    <input
                        type="password"
                        placeholder="Repetir contraseña"
                        required
                        value={repeatPassword}
                        onChange={(e) => setRepeatPassword(e.target.value)}
                    ></input>
                    <label>Nombre </label>
                    <input
                        type="text"
                        placeholder="Nombre"
                        required
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <label>Apellido </label>
                    <input
                        type="text"
                        placeholder="Apellido"
                        required
                        value={lastName}
                        onChange={(e) => setLastName(e.target.value)}
                    ></input>

                    <label>DNI</label>
                    <input
                        type="text"
                        placeholder="DNI"
                        required
                        value={dni}
                        onChange={(e) => setDni(e.target.value)}
                    ></input>

                    <label>Teléfono</label>
                    <input
                        type="number"
                        placeholder="Teléfono"
                        required
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    ></input>

                    <select
                        required
                        value={team}
                        onChange={(e) => setTeam(e.target.value)}
                    >
                        <option disabled value="">
                            Elegí tu equipo LPF preferido
                        </option>
                        <option value="Argentinos Juniors">
                            Argentinos Juniors
                        </option>
                        <option value="Arsenal">Arsenal</option>
                        <option value="Atletico Tucumán">
                            Atlético Tucumán
                        </option>
                        <option value="Banfield">Banfield</option>
                        <option value="Barracas Central">
                            Barracas Central
                        </option>
                        <option value="Belgrano">Belgrano</option>
                        <option value="Boca Juniors">Boca Juniors</option>
                        <option value="Central Cordoba">Central Córdoba</option>
                        <option value="Colon">Colón</option>
                        <option value="Defensa y Justicia">
                            Defensa y Justicia
                        </option>
                        <option value="Estudiantes">Estudiantes</option>
                        <option value="Gimnasia y Esgrima">
                            Gimnasia y Esgrima
                        </option>
                        <option value="Godoy Cruz">Godoy Cruz</option>
                        <option value="Huracan">Huracán</option>
                        <option value="Independiente">Independiente</option>
                        <option value="Ind Rivadavia">Independiente (R)</option>
                        <option value="Instituto">Instituto</option>
                        <option value="Lanus">Lanús</option>
                        <option value="Newells Old Boys">
                            Newell´s Old Boys
                        </option>
                        <option value="Platense">Platense</option>
                        <option value="Racing Club">Racing Club</option>
                        <option value="Riestra">Dep. Riestra</option>
                        <option value="River Plate">River Plate</option>
                        <option value="Rosario Central">Rosario Central</option>
                        <option value="San Lorenzo">San Lorenzo</option>
                        <option value="Sarmiento">Sarmiento</option>
                        <option value="Talleres">Talleres</option>
                        <option value="Tigre">Tigre</option>
                        <option value="Union">Unión</option>
                        <option value="Velez Sarsfield">Vélez Sarsfield</option>
                        <option value="Otro">Otro</option>
                    </select>

                    <p>
                        Al registrarme, acepto los
                        <Link href="/terms">
                            <a className="signupLink">Términos y condiciones</a>
                        </Link>
                    </p>

                    <button disabled={loading}>Registrate</button>
                    {errorMessage && <p className="error">{errorMessage}</p>}

                    {/* ESTO DEJARLO COMENTADO */}
                    {/* {!posting && <button>Ingresar</button>}
          {posting && <button disabled>Posting to your blog!</button>} */}

                    <div className="no-account">
                        ¿Ya tenés una cuenta?{' '}
                        <Link href="/signin">
                            <a className="signupLink">Ingresá acá</a>
                        </Link>
                        .
                    </div>
                </form>
            </div>
        </>
    );
}

SignUpComplete.getLayout = function getLayout(page) {
    return (
        <Layout title="Registrate en LPF Play" className="signup form-pages">
            {page}
        </Layout>
    );
};

export async function getServerSideProps(ctx) {
    const session = await getSession(ctx);

    if (session) {
        return {
            redirect: {
                permanent: false,
                destination: '/browse',
            },
            props: {},
        };
    }

    // Pass data to the page via props
    return { props: { session: session } };
}
